$("body").on("click", ".questioner_answer_master  h2", function () {
  $(this).toggleClass("active");
  $(this)
    .closest(".questioner_answer_master")
    .find(".questions_answers")
    .slideToggle();
});

$("body").on("click", ".questions_answers  h3", function () {
  $(this).toggleClass("active");
  $(this).closest(".questions_answers").find(".answers").slideToggle();
});

if (localStorage.getItem("age-confirm") === null) {
  $("body").addClass("popup-active");
  $("body").find(".age_popup_section").addClass("open-model");
}

$("body").on("click", ".age_1", function () {
  $(".age_confirom").slideToggle();
  $(".age_not_confirom").slideToggle();
  setTimeout(function () {
    window.location.href = "https://www.google.com/";
  }, 3000);
});

$("body").on("click", ".age_2", function () {
  localStorage.setItem("age-confirm", "age-confirm");
  $("body").find(".age_popup_section").removeClass("open-model");
  $("body").removeClass("popup-active");
  // $("body").find(".cookie_popup_section").addClass("open-model");
});

$("body").on("click", ".popup_close", function () {
  $(this).closest(".open-model").removeClass("open-model");
  $("body").removeClass("popup-active");
  // $("body").find(".cookie_popup_section").addClass("open-model");
  $(".cart-link__bubble").removeClass("cart-link__bubble--visible");
  $(".cart-link__bubble-num").text(0);
});

// $("body").on("click", ".cookie_2", function () {
//   $("body").find(".cookie_popup_section").removeClass("open-model");
//   $("body").removeClass("popup-active")
// });

$("body").on("click", ".slide-nav__button_close", function () {
  $(this)
    .closest(".slide-nav__item")
    .find(".child-nav__dropdown")
    .slideToggle();
  $(this).find(".slide-nav__link").addClass("active");
  $(this).addClass($(this).attr("data-class"));
  $(this).addClass("slide-nav__button_open");
  $(this).removeClass("slide-nav__button_close");
});

$("body").on("click", ".slide-nav__button_open", function () {
  $(this)
    .closest(".slide-nav__item")
    .find(".child-nav__dropdown")
    .slideToggle();
  $(this).find(".slide-nav__link").removeClass("active");
  $(this).removeClass($(this).attr("data-class"));
  $(this).removeClass("slide-nav__button_open");
  $(this).addClass("slide-nav__button_close");
});

$("body").on("click", ".chat_button", function (e) {
  e.preventDefault();
  window.HubSpotConversations.widget.open();
});

$("body").on("change", ".variant_input_check", function () {
  $(".error_message").hide();
  var labelText,
    qtyText,
    product_atc,
    product_qty,
    productPageInventory,
    price,
    qty,
    ele,
    productForm;
  labelText = $(this).closest(".variant-input").find("label");
  if (
    $(labelText).text().indexOf("Azee") >= 0 ||
    $(labelText).text().indexOf("Deyaa") >= 0
  ) {
    $(".page-content.page-content--product").addClass("black-content");
    $(".product_meta_title.special_addition").show();
    $(".product_meta_title.normal_product").hide();
    $("#special_addition").show();
  } else {
    $(".page-content.page-content--product").removeClass("black-content");
    $(".product_meta_title.special_addition").hide();
    $(".product_meta_title.normal_product").show();
    $("#special_addition").hide();
  }
  productForm = $(".product-form-block");
  $(this)
    .closest(".variant-input-wrap")
    .find(".variant-input")
    .removeClass("active");
  $(this)
    .closest(".variant-input-wrap")
    .find(".variant_input_check")
    .removeClass("selected-variant");
  if ($(this).hasClass("disabled")) {
    $(this).prop("checked", false);
    $(this)
      .closest(".flavor_product_detail")
      .find(".control")
      .addClass("op-0-5");
    $(this)
      .closest(".flavor_product_detail")
      .find(".control")
      .find("input")
      .val(0);
  } else {
    $(this).closest(".variant-input").addClass("active");
    $(this).addClass("selected-variant");
    $(this)
      .closest(".flavor_product_detail")
      .find(".control")
      .removeClass("op-0-5");
  }

  $(this)
    .closest(".variant-wrapper")
    .find(".variant__label-info")
    .find("span")
    .text($(labelText).text());
  if ($(labelText).text() === "Deyaa" || $(labelText).text() === "Azee") {
    $(".color_name").text(
      $(labelText).text().toUpperCase() + " limited edition"
    );
  } else {
    $(".color_name").text($(labelText).text());
  }
  $(".selected-color").css("background-color", $(labelText).text());

  qtyText = $(this).closest(".grid-item__content").find(".product-inventory");
  product_atc = $(this)
    .closest(".product_variants_collections")
    .find(".product_atc");
  product_qty = $(this)
    .closest(".product_variants_collections")
    .find(".form-qty");

  productPageInventory = $(this)
    .closest("div[data-product-blocks]")
    .find(".product-inventory");

  if ($(this).hasClass("disabled")) {
    /*
    $(qtyText).removeClass("in-stock");
    $(qtyText).addClass("out-stock");
    $(qtyText).find("span").text("OUT OF STOCK");

    $(productPageInventory).removeClass("in-stock");
    $(productPageInventory).addClass("out-stock");
    $(productPageInventory).find("span").text("OUT OF STOCK");
    */

    $(product_atc).addClass("bg-soldOut wd-100");
    $(product_qty).hide();
    $(product_atc).find("span").text(theme.strings.soldOut);

    $(productForm).find(".product-grid-form").hide();
    $(productForm).find("form").css("width", "100%");
  } else {
    /*
    $(qtyText).addClass("in-stock");
    $(qtyText).removeClass("out-stock");
    $(qtyText).find("span").text("IN STOCK");

    $(productPageInventory).addClass("in-stock");
    $(productPageInventory).removeClass("out-stock");
    $(productPageInventory).find("span").text("IN STOCK");
*/

    $(product_atc).removeClass("bg-soldOut wd-100");
    $(product_qty).show();
    $(product_atc).find("span").text(theme.strings.addToCart);

    $(productForm).find(".product-grid-form").show();
    $(productForm).find("form").css("width", "auto");
  }

  price = $(this).closest(".variant-input").attr("data-price");
  qty = parseInt(
    $(this).closest(".product_variants_collections").find(".qty").val()
  );
  if (qty) {
    qty = qty;
  } else {
    qty = parseInt(
      $(this).closest("div[data-product-blocks]").find(".qty").val()
    );
  }

  ele = $(this)
    .closest(".product_variants_collections")
    .closest(".grid-item__content")
    .find(".grid-product__price--current")
    .find("span[aria-hidden='true']");
  if (ele.length > 0) {
    ele = ele;
  } else {
    ele = $(this)
      .closest("div[data-product-blocks]")
      .find(".product__price")
      .find("span[aria-hidden='true']");
  }

  if ($(this).hasClass("disabled")) {
  } else {
    colorSwatchRecommendation(this);
  }

  var variantLength = $(".product-grid__content").find(".variant-input");
  $(".rte.multiple_description").hide();

  for (var i = 0; i < variantLength.length; i++) {
    if ($(variantLength[i]).hasClass("active")) {
      var children = i + 1;
      $(".rte.multiple_description:nth-child(" + children + ")").show();
    }
  }
});

$("body").on("click", ".add-to-cart-grid", function () {
  var productId = $(this)
    .closest(".product_variants_collections")
    .find(".selected-variant")
    .closest(".variant-input")
    .attr("data-id");
  if (productId) {
    productId = productId;
  } else {
    productId = $(this)
      .closest(".product_variants_collections")
      .find(".height-67")
      .attr("data-id");
  }
  $(this).find("span").text(theme.strings.addToCart);

  var gaData = $(this).closest("[ga-item-data]");

  addToCart(productId, $(this), {
    item_name: $(gaData).attr("data-title"), // Name or ID is required.
    item_id: $(gaData).attr("data-sku"),
    item_brand: "Velo",
    item_category: $(gaData).attr("data-category"),
    //item_category_2: $(gaData).attr("data-category-2"),
   // item_category_3: $(gaData).attr("data-category-3"),
   // item_category_4: $(gaData).attr("data-category-4"),
    item_variant: $(gaData).attr("data-variant"),
    item_list_name: $(gaData).attr("data-list-name"),
    item_list_id: $(gaData).attr("data-list-id"),
    index: $(gaData).attr("data-index"),
    quantity: "1",
    price: $(gaData).attr("data-price"),
  });
});

$("body").on("click", ".read_more_less", function () {
  $(this).closest(".collection_description").find("p").toggleClass("open");
  $(this).toggleClass("open");
  if ($(this).find("span").text() == "Show More") {
    $(this).find("span").text("Show Less");
  } else {
    $(this).find("span").text("Show More");
  }
});

var dataCount = "";

function addToCart(productId, grid_button, layerItem) {
  setTimeout(function () {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        items: [
          {
            quantity: 1,
            id: productId,
          },
        ],
      },
      success: function (data) {
        openCart();
      },
      error: function (data) {
        if (data.responseJSON.status == 422 && $('.discount_popup').length) {
          //console.log("data.responseJSON", data.responseJSON);
          $('.discount_popup #discountPopupText').html('<p>' + data.responseJSON.message + '</p>')
          $('.discount_popup').addClass('open-model');//.html('').addClass('open-model');
          $("body").addClass("popup-active");
        } else {
          $(grid_button)
            .closest(".product_form_wrap")
            .find(".error_message")
            .fadeIn();
          $(grid_button)
            .closest(".product_form_wrap")
            .find(".error_message")
            .text(data.responseJSON.description);
          $(grid_button).find("span").text(theme.strings.addToCart);
          setTimeout(function () {
            $(grid_button)
              .closest(".product_form_wrap")
              .find(".error_message")
              .fadeOut();
          }, 4000);
        }
      },
    });
  }, 0);
}

function colorSwatchRecommendation(e) {
  colorImages = $(e).closest(".variant-input").find("label[data-variant-id]");

  if (colorImages.length) {
    setActiveColorImage(colorImages);
  }
}

function setActiveColorImage(swatch) {
  var id = $(swatch).attr("data-variant-id");
  var image = $(swatch).attr("data-variant-image");
  if (image) {
    $(".grid-product__color-image").removeClass("is-active");
    // Set active image and swatch
    var imageEl = $(swatch)
      .closest(".grid-item__content")
      .find(".grid-product__color-image--" + id);
    $(imageEl).css("background-image", "url(" + image + ")");
    //   imageEl.style.backgroundImage = 'url(' + image + ')';
    $(imageEl).addClass("is-active");
  }
  // Update product grid item href with variant URL
  var variantUrl = $(swatch).attr("data-url");
  var gridItem = $(swatch)
    .closest(".grid-item__content")
    .find(".grid-item__link");

  $(gridItem).attr("href", variantUrl);
}

function round(x) {
  return Math.ceil(x / 5) * 5;
}

function bundleATC(items) {
  var data = {
    items,
  };

  //   return;
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: data,
    success: function (data) {
      openCart();
    },
  });
}

function md5cycle(x, k) {
  var a = x[0],
    b = x[1],
    c = x[2],
    d = x[3];

  a = ff(a, b, c, d, k[0], 7, -680876936);
  d = ff(d, a, b, c, k[1], 12, -389564586);
  c = ff(c, d, a, b, k[2], 17, 606105819);
  b = ff(b, c, d, a, k[3], 22, -1044525330);
  a = ff(a, b, c, d, k[4], 7, -176418897);
  d = ff(d, a, b, c, k[5], 12, 1200080426);
  c = ff(c, d, a, b, k[6], 17, -1473231341);
  b = ff(b, c, d, a, k[7], 22, -45705983);
  a = ff(a, b, c, d, k[8], 7, 1770035416);
  d = ff(d, a, b, c, k[9], 12, -1958414417);
  c = ff(c, d, a, b, k[10], 17, -42063);
  b = ff(b, c, d, a, k[11], 22, -1990404162);
  a = ff(a, b, c, d, k[12], 7, 1804603682);
  d = ff(d, a, b, c, k[13], 12, -40341101);
  c = ff(c, d, a, b, k[14], 17, -1502002290);
  b = ff(b, c, d, a, k[15], 22, 1236535329);

  a = gg(a, b, c, d, k[1], 5, -165796510);
  d = gg(d, a, b, c, k[6], 9, -1069501632);
  c = gg(c, d, a, b, k[11], 14, 643717713);
  b = gg(b, c, d, a, k[0], 20, -373897302);
  a = gg(a, b, c, d, k[5], 5, -701558691);
  d = gg(d, a, b, c, k[10], 9, 38016083);
  c = gg(c, d, a, b, k[15], 14, -660478335);
  b = gg(b, c, d, a, k[4], 20, -405537848);
  a = gg(a, b, c, d, k[9], 5, 568446438);
  d = gg(d, a, b, c, k[14], 9, -1019803690);
  c = gg(c, d, a, b, k[3], 14, -187363961);
  b = gg(b, c, d, a, k[8], 20, 1163531501);
  a = gg(a, b, c, d, k[13], 5, -1444681467);
  d = gg(d, a, b, c, k[2], 9, -51403784);
  c = gg(c, d, a, b, k[7], 14, 1735328473);
  b = gg(b, c, d, a, k[12], 20, -1926607734);

  a = hh(a, b, c, d, k[5], 4, -378558);
  d = hh(d, a, b, c, k[8], 11, -2022574463);
  c = hh(c, d, a, b, k[11], 16, 1839030562);
  b = hh(b, c, d, a, k[14], 23, -35309556);
  a = hh(a, b, c, d, k[1], 4, -1530992060);
  d = hh(d, a, b, c, k[4], 11, 1272893353);
  c = hh(c, d, a, b, k[7], 16, -155497632);
  b = hh(b, c, d, a, k[10], 23, -1094730640);
  a = hh(a, b, c, d, k[13], 4, 681279174);
  d = hh(d, a, b, c, k[0], 11, -358537222);
  c = hh(c, d, a, b, k[3], 16, -722521979);
  b = hh(b, c, d, a, k[6], 23, 76029189);
  a = hh(a, b, c, d, k[9], 4, -640364487);
  d = hh(d, a, b, c, k[12], 11, -421815835);
  c = hh(c, d, a, b, k[15], 16, 530742520);
  b = hh(b, c, d, a, k[2], 23, -995338651);

  a = ii(a, b, c, d, k[0], 6, -198630844);
  d = ii(d, a, b, c, k[7], 10, 1126891415);
  c = ii(c, d, a, b, k[14], 15, -1416354905);
  b = ii(b, c, d, a, k[5], 21, -57434055);
  a = ii(a, b, c, d, k[12], 6, 1700485571);
  d = ii(d, a, b, c, k[3], 10, -1894986606);
  c = ii(c, d, a, b, k[10], 15, -1051523);
  b = ii(b, c, d, a, k[1], 21, -2054922799);
  a = ii(a, b, c, d, k[8], 6, 1873313359);
  d = ii(d, a, b, c, k[15], 10, -30611744);
  c = ii(c, d, a, b, k[6], 15, -1560198380);
  b = ii(b, c, d, a, k[13], 21, 1309151649);
  a = ii(a, b, c, d, k[4], 6, -145523070);
  d = ii(d, a, b, c, k[11], 10, -1120210379);
  c = ii(c, d, a, b, k[2], 15, 718787259);
  b = ii(b, c, d, a, k[9], 21, -343485551);

  x[0] = add32(a, x[0]);
  x[1] = add32(b, x[1]);
  x[2] = add32(c, x[2]);
  x[3] = add32(d, x[3]);
}

function cmn(q, a, b, x, s, t) {
  a = add32(add32(a, q), add32(x, t));
  return add32((a << s) | (a >>> (32 - s)), b);
}

function ff(a, b, c, d, x, s, t) {
  return cmn((b & c) | (~b & d), a, b, x, s, t);
}

function gg(a, b, c, d, x, s, t) {
  return cmn((b & d) | (c & ~d), a, b, x, s, t);
}

function hh(a, b, c, d, x, s, t) {
  return cmn(b ^ c ^ d, a, b, x, s, t);
}

function ii(a, b, c, d, x, s, t) {
  return cmn(c ^ (b | ~d), a, b, x, s, t);
}

function md51(s) {
  var txt = "";
  var n = s.length,
    state = [1732584193, -271733879, -1732584194, 271733878],
    i;
  for (i = 64; i <= s.length; i += 64) {
    md5cycle(state, md5blk(s.substring(i - 64, i)));
  }
  s = s.substring(i - 64);
  var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  for (i = 0; i < s.length; i++)
    tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
  tail[i >> 2] |= 0x80 << (i % 4 << 3);
  if (i > 55) {
    md5cycle(state, tail);
    for (i = 0; i < 16; i++) tail[i] = 0;
  }
  tail[14] = n * 8;
  md5cycle(state, tail);
  return state;
}
function md5blk(s) {
  var md5blks = [],
    i;
  for (i = 0; i < 64; i += 4) {
    md5blks[i >> 2] =
      s.charCodeAt(i) +
      (s.charCodeAt(i + 1) << 8) +
      (s.charCodeAt(i + 2) << 16) +
      (s.charCodeAt(i + 3) << 24);
  }
  return md5blks;
}

var hex_chr = "0123456789abcdef".split("");

function rhex(n) {
  var s = "",
    j = 0;
  for (; j < 4; j++)
    s += hex_chr[(n >> (j * 8 + 4)) & 0x0f] + hex_chr[(n >> (j * 8)) & 0x0f];
  return s;
}

function hex(x) {
  for (var i = 0; i < x.length; i++) x[i] = rhex(x[i]);
  return x.join("");
}

function md5(s) {
  return hex(md51(s));
}
function add32(a, b) {
  return (a + b) & 0xffffffff;
}
if (md5("hello") != "5d41402abc4b2a76b9719d911017c592") {
  function add32(x, y) {
    var lsw = (x & 0xffff) + (y & 0xffff),
      msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return (msw << 16) | (lsw & 0xffff);
  }
}

function discountMessage(message) {
  $(document)
  .find(".discount_panel_form")
  .find(".error_message")
  .removeClass("error_message")
  .addClass("success_message")
  .text(message)
  .fadeIn();
setTimeout(function(){
  $('.discount_popup').removeClass('open-model');
  $("body").removeClass("popup-active");
  setTimeout(function(){
    $('.discount_popup').remove();
  }, 300)
}, 3500)
setTimeout(function () {
  $(document)
    .find(".discount_panel_form")
    .find(".success_message")
    .removeClass("success_message")
    .addClass("error_message")
    .fadeOut();
}, 4000);
}

window.setDiscount = function (discount) {
  var discountmd5 = md5(discount);
  if (window.md5c.indexOf(discountmd5) > -1) {
    $(document).find(".discount_panel_form input").addClass("success");
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ attributes: { discount: discount } }),
    }).then(function () {
      if( localStorage.getItem('trytoadd') ) {
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: [{ id: localStorage.getItem('trytoadd'), quantity: 1 }] })
        }).then(function () {
          localStorage.removeItem('trytoadd');
          openCart();
        })
      }
      
    });
    discountMessage(theme.strings.discountAdded)
  } else {
    var updates = {};
    updates.updates = [];
    var needRefresh = false;
    $(document)
      .find(".discount_panel_form")
      .find(".error_message")
      .text(theme.strings.wrongDiscount)
      .fadeIn();
    setTimeout(function () {
      $(document).find(".discount_panel_form").find(".error_message").fadeOut();
    }, 4000);
    Array.from(
      document.querySelectorAll(
        ".cart__page-form .cart__item, .cart_main_items_master .cart__item"
      )
    ).forEach(function (cartItem, i) {
      if (i == 0) {
        updates.updates.push(1);
        if (
          cartItem.getAttribute("data-qty") &&
          parseInt(cartItem.getAttribute("data-qty")) > 1
        ) {
          needRefresh = true;
        }
      } else {
        updates.updates.push(0);
        needRefresh = true;
      }
    });
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updates),
    }).then(function () {
      updates.attributes = { discount: "" };
      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updates),
      }).then(function () {
        if (needRefresh) {
          window.location.reload();
        }
      });
    });
  }
};

$("body").on("click", ".checkout_discount_button", function (e) {
  e.preventDefault();
  var discount = $('input[name="attributes[discount]"]').val();
  if( theme.customerTags && theme.customerTags.indexOf("ATTR_" + discount) > -1 ) {
    discountMessage("Sie haben diesen Code bereits verwendet")
  } else {
    window.setDiscount(discount);
  }
});

$("body").on("click", ".cart__continue", function (e) {
  e.preventDefault();
  window.location.href = document.referrer;
});

$("body").on("click", ".eye-close-open", function (e) {
  $(this).closest(".password_field").find(".eye-open").toggleClass("hide");
  $(this).closest(".password_field").find(".eye-close").toggleClass("hide");
  if (
    $(this).closest(".password_field").find(".input-full").attr("type") ===
    "password"
  ) {
    $(this).closest(".password_field").find(".input-full").attr("type", "text");
  } else {
    $(this)
      .closest(".password_field")
      .find(".input-full")
      .attr("type", "password");
  }
});

$("body").on("click", ".address-edit", function () {
  var id = $(this).attr("data-form-id");
  var defaultCityVal = $("#EditAddress_" + id)
    .find(".default-address-city")
    .data("title");
  $("#AddressCity_" + id).val(defaultCityVal);
  $("#EditAddress_" + id).toggleClass("hide");
});

$("body").on("click", ".add-to-cart_custom", function (e) {
  e.preventDefault();
  var qty = $(this).closest(".product-form-block").find(".js-qty__num").val();
  var productId = $(".product_variant_picker")
    .find(".variant-input.active")
    .attr("data-id");

  if (typeof productId === "undefined") {
    productId = $(".product-single__variants").val();
  }
  var sku = $(".product_variant_picker")
    .find(".variant-input.active")
    .attr("data-sku");
  var parentDiv = $(this).closest(".product-grid__content");
  var productPrice = $(parentDiv)
    .find(".product__price")
    .find(".visually-hidden")
    .text();
  var variant = $(parentDiv).find(".variant-input.active").attr("data-value");

  var collectionName = $(parentDiv)
    .closest(".product-section")
    .attr("data-collection");
  var productTitle = $(parentDiv)
    .closest(".product-section")
    .attr("data-product-title");
  var optionName = $(parentDiv).find(".variant__label").text();

  var gaData = $(this).closest("[ga-item-data]");

  addToCart(productId, $(this), {
    item_name: $(gaData).attr("data-title"), // Name or ID is required.
    item_id: $(gaData).attr("data-sku"),
    item_brand: "Velo",
    item_category: $(gaData).attr("data-category"),
    //item_category_2: $(gaData).attr("data-category-2"),
    //item_category_3: $(gaData).attr("data-category-3"),
   // item_category_4: $(gaData).attr("data-category-4"),
    item_variant: $(gaData).attr("data-variant"),
    quantity: "1",
    price: $(gaData).attr("data-price"),
  });
});

function updateCart(productId, qty) {
  var cartNumber = parseInt($(".cart-link__bubble-num").text());
  var totalQty = cartNumber + 1;
  if (totalQty <= 1) {
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: {
        quantity: qty,
        id: productId,
      },
      dataType: "json",
      success: function (cart) {
        openCart();
      },
    });
  } else {
    $(".add-to-cart_custom").text(theme.strings.addToCart);
    CartFullPoup();
  }
}

function openCart() {
  $.ajax({
    type: "GET",
    url: "/cart?view=drawer",
    async: false,
    success: function (cart) {
      $(".drawer__cart").html("");
      $(".drawer__cart").html(cart);
      $(".overlay").addClass("overlay-open");
      $("body").addClass("drawer-open");
      $("#myModal").addClass("view-model");
      var cartCount = parseInt(
        $("#myModal").find(".cart_count").attr("data-id")
      );
      var cartPrice = $("#myModal")
        .find(".total_price")
        .find("span[aria-hidden='true']")
        .text();
      if (cartCount > 0) {
        $(".cart-link__bubble").addClass("cart-link__bubble--visible");
        $("#HeaderCartTrigger")
          .find(".site-nav__icon-label.small--hide")
          .text(cartPrice);
      } else {
        $(".cart-link__bubble").removeClass("cart-link__bubble--visible");
        $("#HeaderCartTrigger")
          .find(".site-nav__icon-label.small--hide")
          .text("€0.00");
      }
      $(".cart-link__bubble-num").text(cartCount);
    },
  });
}

var container = $(".my-modal");
$(document).click(function () {
  if (
    !container.is(event.target) &&
    !container.has(event.target).length &&
    $(".my-modal.view-model").length
  ) {
    $(".my-modal").removeClass("view-model");
    $(".overlay").removeClass("overlay-open");
    $("body").removeClass("drawer-open");
  }
});

$(document).on("keydown", function (e) {
  if (e.keyCode === 27) {
    // ESC
    $(".my-modal").removeClass("view-model");
    $(".overlay").removeClass("overlay-open");
    $("body").removeClass("drawer-open");
  }
});

$("body").on("click", ".close_model, .basket_button", function () {
  $(".my-modal").removeClass("view-model");
  $(".overlay").removeClass("overlay-open");
  $("body").removeClass("drawer-open");
});

$("#myFilters").detach().appendTo('body')
$(document).on("click", ".filter__button", function () {
  setTimeout(function () {
    $("#myFilters").addClass("view-model");
    $(".overlay").addClass("overlay-open");
    $("body").addClass("drawer-open");
  }, 0);
});

var addressId = "";
$("body").on("click", ".address_delete_custom", function () {
  addressId = $(this).attr("data-id");
  $(".overlay").addClass("overlay-opens");
  $("body").addClass("drawer-opens");
  $(".address_remove_popup").addClass("view-address-model");
});

$("body").on("click", ".address_remove_btn_1", function () {
  Shopify.postLink("/account/addresses/" + addressId, {
    parameters: {
      _method: "delete",
    },
  });
});
$("body").on("click", ".address_remove_btn_2, .close_address", function () {
  $(".overlay").removeClass("overlay-opens");
  $("body").removeClass("drawer-opens");
  $(".address_remove_popup").removeClass("view-address-model");
});

$("body").on("click", ".close_password", function () {
  $(".overlay").removeClass("overlay-opens-password");
  $("body").removeClass("drawer-opens-password");
  $(".reset_password_success").removeClass("view-address-model");
  $(".clear_cart_popup").removeClass("view-address-model");
  //  $(".qty_cart_popup").removeClass("view-address-model view-cart-model");
});
$("body").on("click", ".close_login_form", function () {
  $(".overlay").removeClass("overlay-opens-password");
  $("body").removeClass("drawer-opens-password");
  $(".social_login_master_form").removeClass("view-address-model");
  $("#google_login").find("span").text("sign in with google");
  $("#facebook_login").find("span").text("sign in with facebook");
  $(".facebook_login_btn").addClass("pointer-none");
  $(".google_login_btn").addClass("pointer-none");
  Shopify.analytics.publish('login_failure', {
    event: "login_failure",
    eventAction: "failure",
    eventLabel: "cancel",
    eventCategory: "login",
  });
});

var msg = $(".errors").find("li").text();
var index = msg.indexOf(
  "please click the link included to verify your email address"
);
if (index !== -1) {
  $(".errors").addClass("email_successfull");
  Shopify.analytics.publish('registartion', {
    event: "registartion",
    eventAction: "registartion",
    eventLabel: "success",
  });
}

if($('.registration_successful_master').length > 0) {
     dataLayerHandler.pushEvent({
        'event': 'registration',
        'eventAction': 'registration Success',
        'eventLabel': 'success'
      });
  }

  if(window.location.href.indexOf("loggedIn=true") > -1) {
       dataLayerHandler.pushEvent({
          'event': 'account',
          'eventAction': 'login',
          'eventLabel': 'success'

        });
    }

var lognFailed = msg.indexOf("Die E-Mail-Adresse oder das Passwort ist falsch.");
if (lognFailed !== -1) {
   dataLayerHandler.pushEvent({
     event: "account",
     eventAction: "login",
     eventLabel: "fail",
     errorType: "incorrect_credentials",
     errorFields: "Incorrect email or password."
   });
 }

$("body").on("click", ".grid-item__link", function (e) {
  e.preventDefault();
  var redirectLink = $(this).attr("href");

  var gaData = $(this).closest("[ga-item-data]");

  Shopify.analytics.publish('select_item', {
    event: "select_item",
    ecommerce: {
      items: [
        {
          item_name: $(gaData).attr("data-title"), // Name or ID is required.
          item_id: $(gaData).attr("data-sku"),
          item_brand: "Velo",
          item_category: $(gaData).attr("data-category"),
          //item_category_2: $(gaData).attr("data-category-2"),
         // item_category_3: $(gaData).attr("data-category-3"),
         // item_category_4: $(gaData).attr("data-category-4"),
          item_variant: $(gaData).attr("data-variant"),
          item_list_name: $(gaData).attr("data-list-name"),
          item_list_id: $(gaData).attr("data-list-id"),
          index: $(gaData).attr("data-index"),
          quantity: "1",
          price: $(gaData).attr("data-price"),
        },
      ],
    },
  });
  window.location.href = redirectLink;
});

$("body").on("click", ".account_sign_out", function () {
  Shopify.analytics.publish('account', {
    event: "account",
    eventAction: "logout",
    eventLabel: "success",
  });
});

$("body").on("click", ".no-customer", function () {
  Shopify.analytics.publish('login_attempt', {
    event: "login_attempt",
    eventAction: "attempt",
    eventLabel: "signin",
    eventCategory: "login",
  })
});

$("body").on("click", ".filter_option", function () {
  $(".filter_option").removeClass("filter_clicked");
  $(this).addClass("filter_clicked");

  var tagText = "_" + $(this).attr("data-text");
  var collectionHandle = $(this).attr("data-collection");
  if (tagText === "_all") {
    $.ajax({
      type: "GET",
      url: "/collections/" + collectionHandle + "/?view=sort-by",
      async: false,
      success: function (data) {
        $(".collection_grid_master").html("");
        $(".collection_grid_master").html(data);
        $(".my-modal").removeClass("view-model");
        $(".overlay").removeClass("overlay-open");
        $("body").removeClass("drawer-open");
      },
    });
  } else {
    $.ajax({
      type: "GET",
      url: "/collections/" + collectionHandle + "/" + tagText + "?view=sort-by",
      async: false,
      success: function (data) {
        $(".collection_grid_master").html("");
        $(".collection_grid_master").html(data);
        $(".my-modal").removeClass("view-model");
        $(".overlay").removeClass("overlay-open");
        $("body").removeClass("drawer-open");
      },
    });
  }
});

document.addEventListener("filter:selected", function () {
  $(".my-modal").removeClass("view-model");
  $(".overlay").removeClass("overlay-open");
  $("body").removeClass("drawer-open");
});

function CartFullPoup() {
  $(".overlay").addClass("overlay-opens-password");
  $("body").addClass("drawer-opens-password");
  $(".qty_cart_popup").addClass("view-address-model view-cart-model");
}

$("body").on("click", ".clear_cart_button", function (e) {
  e.preventDefault();
  $.ajax({
    type: "POST",
    url: "/cart/clear.js",
    dataType: "json",
    data: "",
    success: function (data) {},
    error: function (data) {},
  });
});

$("body").on("click", ".show_more_section_2", function () {
  $(".abt_section_2_right").slideToggle();
  $(this).hide();
});

$("body").on("click", ".show_less_section_2", function () {
  $(".abt_section_2_right").slideToggle();
  $(".show_more_section_2").show();
});

$("body").on("click", ".show_more", function () {
  $(".abt_section_5_left").addClass("open");
  $(this).hide();
  $(".show_less").show();
});

$("body").on("click", ".show_less", function () {
  $(".abt_section_5_left").removeClass("open");
  $(this).hide();
  $(".show_more").show();
});

$("body").on("click", ".slide_item", function () {
  $(".left_inner_img").find("img").attr("src", $(this).data("image"));
  $(".left_inner_text")
    .find("h3")
    .find("span")
    .text($(this).find(".season_ep").text());
  $(".left_inner_text").find("a").attr("href", $(this).data("link"));
});

$(window).scroll(function (event) {
  if ($(window).scrollTop() > 65) {
    $("#shopify-section-header-bottom").addClass("header_bottom_fixed");
  } else {
    $("#shopify-section-header-bottom").removeClass("header_bottom_fixed");
  }
});

if (window.location.href.indexOf("?checkout_url=https") > -1) {
  const url = new URL(location);
  url.searchParams.delete("checkout_url");
  var newurl =
    window.location.protocol +
    "//" +
    window.location.host +
    window.location.pathname +
    "?checkout_url=/cart";
  window.location.href = newurl;
}

function removeCart() {
  $.ajax({
    type: "GET",
    url: "/cart",
    dataType: "json",
    success: function (data) {
      if (data.item_count >= 10) {
        freeCanPoup();
        return false;
      }
      // else{
      //   freeCanPoup();
      // }
    },
    error: function (data) {},
  });
}

function cartQuantity(itemCount) {
  $.ajax({
    type: "GET",
    url: "/cart",
    dataType: "json",
    success: function (data) {
      itemCount(data.item_count);
    },
    error: function (data) {},
  });
}

$(".footer__title").on("click", function () {
  $(this).closest(".footer__block").toggleClass("opened");
});
/* basket status change */
$(document).ready(function(){
  if( sessionStorage.getItem('firstTimeUser') == "true") {
      fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(function () {
      if( localStorage.getItem('trytoadd') ) {
        $(".cart-link__bubble").addClass("cart-link__bubble--visible");
        $(".cart-link__bubble-num").text(1);
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: [{ id: localStorage.getItem('trytoadd'), quantity: 1 }] })
        }).then(function () {
          localStorage.removeItem('trytoadd');
        })
      }
      
    });
  }
});
/* basket status change */